const {
    get_quote_enable,
    get_quote_text,
    quote_position_desktop,
    quote_position_mobile,
    quote_width_desktop,
    quote_width_mobile,
    get_quote_text_color
} = macedoniantranslations.bt_get_quote;

const theForm = document.querySelector('.contact-form-popup');

if( theForm && 'on' === get_quote_enable ) {

    const siteBody = document.querySelector('body');
    const GetQuote = document.createElement('div');
    GetQuote.classList.add('c-GetQuote');
    GetQuote.style.setProperty('--macedoniantranslations-button-get-quote-width', quote_width_desktop);
    GetQuote.style.setProperty('--macedoniantranslations-button-get-quote-pos', quote_position_desktop);

    const GetQuoteButtonWrapper = document.createElement('div')
    GetQuoteButtonWrapper.classList.add('c-GetQuote__btnwrap', 'wp-block-button')

    const GetQuoteButton = document.createElement('button');
    GetQuoteButton.classList.add('c-GetQuote__button', 'wp-block-button__link', 'wp-element-button');
    GetQuoteButton.style.setProperty('--macedoniantranslations-button-get-quote-width', quote_width_desktop);
    GetQuoteButton.style.setProperty('--macedoniantranslations-button-get-quote-text-color', get_quote_text_color);
    GetQuoteButton.innerHTML = get_quote_text;

    GetQuoteButtonWrapper.append(GetQuoteButton);

    GetQuote.append(GetQuoteButtonWrapper)

    siteBody.append(GetQuote);

    GetQuoteButton.addEventListener('click', () => {
        GetQuote.classList.add('clicked');
        theForm.style.visibility = 'visible';
        theForm.style.opacity = 1;

        const close = document.createElement('span');
        close.classList.add('contact-form-popup__close');
        close.innerHTML = 'X';

        theForm.append(close);

        close.addEventListener('click', () => {
            theForm.style.visibility = 'hidden';
            theForm.style.opacity = 0;
            GetQuote.classList.remove('clicked');
        })
    });
    
}